<template>
    <div>
      <div>
        <NotificationMessage v-if="showNotification" :message="notificationMessage" :type="notificationType" :duration="5000"/>
      </div>
        <b-row no-gutters>
            <b-col lg="7" md="5">
                <b-card-text class="info-rapport pt-3 pb-3">
                    <div class="titreRapport pr-2">Rapport n°{{idExecution}} - {{momentDate(executionData.dateExecution)}}</div>
                    <div>exécution du jeu <strong>{{nomJeu}}</strong> composé de <strong>{{ nbRequetesFromJeu }}</strong> requête(s)<br>par <strong>{{ nom }} {{prenom}} - {{email}}</strong><br>Schéma ciblé:
                      <strong>{{ schema }}</strong>  -  Base de donnée ciblée: <strong>{{ bdd }}</strong><br>
                    avec les paramètres : <br>
                    <li style="list-style-type: none" v-for='(parametre,index) in parametres' v-bind:key="index">
                      <strong>{{parametre.parametre}} : {{parametre.valeur}}</strong>
                    </li>
                   </div><br>
                  <p><strong>{{ nbRequetesAno }}</strong> requête(s) en anomalie<br><strong>{{nblignesAno}}</strong> ligne(s) anomalique(s) - <strong>{{nbJustif}}</strong> justifiées - <strong>{{nbValid}}</strong> validées - <strong>{{nbRefuse}}</strong> refusée</p>
                </b-card-text>
            </b-col>

            <b-button pill @click.prevent ="handleShowModalJustif(executionData.idExecution)" align-self="center" id="justifications" class="nav-link5"
            title="visualiser et valider les justifications du rapport">justifications <i class="fas fa-calendar-alt"></i></b-button>

            <b-button pill @click.prevent ="handleShowModalRequeteInExecution(executionData.idExecution)" align-self="center" id="anomalies" class="nav-link1"
            title="visualiser, justifier les anomalies et valider leurs justifications du rapport par requête">anomalies <i class="fas fa-list"></i></b-button>

            <b-button pill type="button" href="#" @click.prevent="getFichier(executionData.idExecution)" align-self="center" class="nav-link4"
            title="Télécharger le rapport au format csv">télécharger <i class="fas fa-download"></i></b-button>

        </b-row>

      <div class ="item">

        <b-col class="mb-2 mt-1 requetes">

          <div id="justif" class="justif" v-if="showModalJustif">
            <div v-if="anomalies.length!==0">
                  <AnomaliesJustifOK
                      :anomalies="anomalies"
                      :idExecution="executionData.idExecution"
                      class="center">
                  </AnomaliesJustifOK>
            </div>
            <div v-else-if="loaded" class = "loading">Pas d'anomalies justifiées pour ce rapport</div>
            <div class = "loading" v-if="!loaded">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span class="ml-2">Chargement en cours...</span>
            </div>
          </div>

          <div class="requete" v-if="showModalRequetesInExecution">
            <div v-if="requetes.length!==0" >
              <div class="pagination mt-3">
                <b-pagination class="customPagination"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              prev-text="précédent"
                              next-text="suivant"
                              aria-controls="my-card"
                              size="sm"
                              align="right">
                </b-pagination>
              </div>
              <p align="left"
                 v-for="requete in find"
                 v-bind:key="requete.idRequete"
                 class="mb-2">
                <RequetesInExecution
                    :idExecution="executionData.idExecution"
                    :requete="requete"
                    class="center">
                </RequetesInExecution>
              </p>
              <div class="pagination mt-3">
                <b-pagination class="customPagination"
                              v-model="currentPage"
                              :total-rows="rows"
                              :per-page="perPage"
                              prev-text="précédent"
                              next-text="suivant"
                              aria-controls="my-card"
                              size="sm"
                              align="right">
                </b-pagination>
              </div>
            </div>
            <div v-else-if="loaded" class = "loading">Aucune requête dans ce rapport.</div>
            <div class = "loading" v-if="!loaded">
              <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
              </div>
              <span class="ml-2">Chargement en cours...</span>
            </div>
          </div>
        </b-col>
      </div>

    </div>
</template>

<script>
import {useRapportFunctions} from "@/composition/Rapports/rapportList";
import RequetesInExecution from '@/components/Rapports/RequetesInExecution.vue'
import AnomaliesJustifOK from '@/components/Rapports/AnomaliesJustifOK.vue'
import NotificationMessage from "@/components/Notification.vue";
export default {
    name:"RapportsItemAccordion",

  components:{
    NotificationMessage,
    RequetesInExecution,
    AnomaliesJustifOK,
  },
    
    props:{
        executionData:{
            type:Object,
            required:true
        },
      id:{
        type:Number
      },
    },

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  setup(props){
    return useRapportFunctions(props);
  },
};
</script>

<style>

.titreRapport{
color: white;
  font-size: 24px;
}

.other{
  color: white;
}

.info-rapport{
    color: white;
    text-align: left;
}
.loading{
  color: white;
}

</style>